export function isNotWhiteSpaceOrEmpty  (str) {
    return str.trim().length > 0;
}